import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { heroChecks, images } from '../data/content';
export function Hero() {
  return <header className="bg-navy text-white" data-id="element-130" data-mp="9kjwmolen43o">
      <div className="bg-cta px-4 py-2 text-center text-xs font-bold uppercase tracking-wide sm:text-sm" data-id="element-131" data-mp="9ll64omrvija">
        Promotional price active · Complete collection for $27
      </div>

      <div className="mx-auto grid max-w-6xl gap-x-12 px-5 pb-14 pt-8 lg:grid-cols-[1.05fr_1fr] lg:items-center lg:pb-20 lg:pt-16" data-id="element-132" data-mp="128fqzmni4jxa">
        <div className="lg:col-start-1" data-id="element-133" data-mp="xb5rfe6eervq">
          <p className="text-sm font-extrabold tracking-wide text-teal-bright sm:text-base" data-id="element-134" data-mp="sb1e1x0sed9q">
            AAC CLINICAL BLUEPRINT™
          </p>
          <p className="mt-1 text-sm text-white/75 sm:text-base" data-id="element-135" data-mp="nbooh4ij6s3g">A Practical System for AAC Planning &amp; Implementation</p>
          <h1 className="mt-5 text-[36px] font-black leading-[1.04] tracking-tight sm:text-5xl lg:text-[56px]" data-id="element-136" data-mp="3czfoc8080na9">
            STOP GUESSING YOUR <span className="text-gold" data-id="element-137" data-mp="3j7zfnjujfuh7">NEXT STEP</span> IN AAC IMPLEMENTATION.
          </h1>
          <p className="mt-5 text-[17px] leading-relaxed text-white/85 sm:text-lg" data-id="element-138" data-mp="3o7bzrwu0yng3">
            Organize your AAC planning process with a practical, step-by-step reference system designed for speech-language pathologists, special education professionals, and communication support teams.
          </p>
        </div>

        <div className="mt-8 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:mt-0" data-id="element-139" data-mp="30hrg1bq1rm5r">
          <img src={images.hero} alt="AAC Clinical Blueprint™ collection: six volumes and five bonus workbooks" className="mx-auto w-full max-w-[560px]" data-id="element-140" data-mp="358ho4wpuy345" />
        </div>

        <div className="mt-8 lg:col-start-1 lg:mt-8" data-id="element-141" data-mp="2vi54r7ts4fzl">
          <p className="text-[16px] leading-relaxed text-white/85" data-id="element-142" data-mp="2vgtwovtawm2o">
            Discover a structured collection of <strong className="text-white" data-id="element-143" data-mp="2hlj983hdz38c">6 practical volumes + 5 specialized bonuses</strong> designed to help you organize communication observations, plan individualized supports, develop visual communication resources, and document implementation across everyday environments.
          </p>

          <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-144" data-mp="n9i3xcn8leu4">
            {heroChecks.map(item => <li key={item} className="flex items-center gap-2.5 rounded-xl bg-navy-soft px-3.5 py-3 text-[15px] font-semibold" data-id="element-145" data-mp="i9vpx0zl3uk9">
                <CheckCircle2Icon className="h-5 w-5 shrink-0 text-teal-bright" aria-hidden="true" data-id="element-146" data-mp="1b1fez1iv42u6" />
                {item}
              </li>)}
          </ul>

          <p className="mt-8 text-center text-lg font-bold lg:text-left" data-id="element-147" data-mp="15zzqt0le1g7k">
            Get the Complete AAC Clinical Blueprint™ for Just{' '}
            <span className="whitespace-nowrap text-3xl font-black text-gold" data-id="element-148" data-mp="x030kujco9ae">$27</span>
          </p>

          <div className="mt-5" data-id="element-149" data-mp="3lu02z1erz4zq">
            <CtaButton id="first-cta" label="Get instant access now" data-id="element-150" data-mp="3lquf1phvu95l" />
          </div>
          <p className="mt-3 text-center text-xs text-white/65 sm:text-sm lg:text-left" data-id="element-151" data-mp="3hpsg79rvnz45">
            Digital educational resource · One-time payment · [CONFIRM DELIVERY METHOD]
          </p>
        </div>
      </div>
    </header>;
}